import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/SalesProforma"
    : "/SLN/SolarentOperator/SalesProforma";

const post = async (source, action, data) => {
  const response = await api.request({
    url: `${resolveBaseUrl(source)}/${action}`,
    method: "POST",
    headers: authHeader(),
    data,
  });
  return response.data;
};

const SalesProformaApi = {
  search: (source = "SolarentOperator", searchParams = {}) =>
    post(source, "Search", searchParams),

  get: async (source = "SolarentOperator", id) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Get`,
      method: "GET",
      params: { id },
      headers: authHeader(),
    });
    return response.data;
  },

  previewFromRequest: async (source = "SolarentOperator", { requestId, trackingCode } = {}) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/PreviewFromRequest`,
      method: "GET",
      params: { requestId, trackingCode },
      headers: authHeader(),
    });
    return response.data;
  },

  saveDraft: (source = "SolarentOperator", payload) => post(source, "SaveDraft", payload),

  issue: (source = "SolarentOperator", payload) => post(source, "Issue", payload),

  finalize: async (source = "SolarentOperator", id) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Finalize`,
      method: "POST",
      params: { id },
      headers: authHeader(),
    });
    return response.data;
  },

  copyFromNumber: async (source = "SolarentOperator", sourceProformaNumber) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/CopyFromNumber`,
      method: "POST",
      params: { sourceProformaNumber },
      headers: authHeader(),
    });
    return response.data;
  },

  deleteDraft: async (source = "SolarentOperator", id) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/DeleteDraft`,
      method: "POST",
      params: { id },
      headers: authHeader(),
    });
    return response.data;
  },

  searchCustomers: async (source = "SolarentOperator", searchText) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/SearchCustomers`,
      method: "GET",
      params: { searchText: searchText ?? "" },
      headers: authHeader(),
    });
    return response.data;
  },

  downloadExcel: (source = "SolarentOperator", id) =>
    api.request({
      url: `${resolveBaseUrl(source)}/DownloadExcel`,
      method: "GET",
      params: { id },
      responseType: "blob",
      headers: authHeader(),
    }),

  downloadPdf: (source = "SolarentOperator", id) =>
    api.request({
      url: `${resolveBaseUrl(source)}/DownloadPdf`,
      method: "GET",
      params: { id },
      responseType: "blob",
      headers: authHeader(),
    }),
};

export default SalesProformaApi;
